"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colours = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
exports.colours = {
    // Job status, measurement verdict and tolerance limit colours
    Aborted: "#C46B90",
    Started: "#b0b0b0",
    Fail: "#FF626D",
    NotApplicable: "#009CE0",
    NotToleranced: "#009CE0",
    Pass: "#8EE43F",
    Warning: "#F93",
    "No Verdict": "#009CE0",
    Completed: "#5CBAB6",
    Incomplete: "#C46B90",
    OuterLimit: "#D12B36",
    Nominal: "#FFF",
};
//# sourceMappingURL=colours.js.map